import { pr } from '@/utils/pxToRem';
import { Typography, Stack } from '@mui/material';
import React from 'react';
import { style } from '@/styles/globals';
import Image from 'next/image';
import { loaderImageVex } from '@/utils/loadImageSeoVex';

const GoyoloPartner = ({ lang }: any) => (
  <Stack spacing={pr`16px`}>
    <Typography
      component="div"
      sx={{
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '30px',
        color: `${style.color.black1}`,
      }}
    >
      {lang?.footer?.paymentPartners || 'Đối tác thanh toán'}
    </Typography>
    <Stack
      spacing={pr`23px`}
      marginTop={pr`23px`}
    >
      <Stack
        spacing={pr`10px`}
        flexWrap="wrap"
        justifyContent="space-between"
        direction="row"
      >
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Partner/jcb.svg"
          alt="logo"
          width="38px"
          height="24px"
          objectFit="contain"
        />
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Partner/cdc.svg"
          alt="logo"
          width="38px"
          height="24px"
          objectFit="contain"
        />
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Partner/visa.svg"
          alt="logo"
          width="38px"
          height="24px"
          objectFit="contain"
        />
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Partner/op.svg"
          alt="logo"
          width="38px"
          height="24px"
          objectFit="contain"
        />
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Partner/sc.svg"
          alt="logo"
          width="38px"
          height="24px"
          objectFit="contain"
        />
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Partner/vb.svg"
          alt="logo"
          width="38px"
          height="24px"
          objectFit="contain"
        />
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Partner/ac.svg"
          alt="logo"
          width="38px"
          height="24px"
          objectFit="contain"
        />
        <Image
          loader={loaderImageVex}
          src="https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/Partner/po.svg"
          alt="logo"
          width="38px"
          height="24px"
          objectFit="contain"
        />
      </Stack>
    </Stack>
  </Stack>
);

export default GoyoloPartner;
